import React from 'react'
import { TailoredProduct } from 'services/api/entities/catalog/types'
import { FilterSelectInput } from 'ui-shared/FilterSelectInput'
import { KFilterFieldProps } from 'ui-shared/KFilters'
import { useFormContext } from 'react-hook-form'
import { FILTER_SOURCES } from 'services/cfg/filter'

const TailoredClientFilter: React.FC<KFilterFieldProps> = ({
  entity,
  source,
  label,
}) => {
  const { getValues, setValue } = useFormContext()

  const handleChange = () => {
    if (getValues(FILTER_SOURCES.visibleToAll)) {
      setValue(FILTER_SOURCES.visibleToAll, '')
    }
  }

  return (
    <FilterSelectInput
      entity={entity}
      label={label}
      searchFn={(e: TailoredProduct) => e.customersFull}
      optionText="email"
      source={source}
      onChange={handleChange}
    />
  )
}

export default TailoredClientFilter
